var map = {
	"./AllChapters": [
		32253,
		2253
	],
	"./AllChapters.json": [
		32253,
		2253
	],
	"./SituationBasedVariation": [
		95652,
		5652
	],
	"./SituationBasedVariation.json": [
		95652,
		5652
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23453;
module.exports = webpackAsyncContext;